import { render, staticRenderFns } from "./purchaseReturn.vue?vue&type=template&id=9202a370"
import script from "./purchaseReturn.vue?vue&type=script&lang=js"
export * from "./purchaseReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports